import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import { Header, Footer } from "./components/Layout";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import PropertiesPage from "./pages/PropertiesPage";
import ValleyPage from "./pages/ValleyPage";
import ContactPage from "./pages/ContactPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

function PageWrapper({ children }) {
  const { pathname } = useLocation();
  return <div key={pathname} className="page-fade">{children}</div>;
}

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Header />
          <div className="flex-1">
            <PageWrapper>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/logements" element={<PropertiesPage />} />
                <Route path="/vallee" element={<ValleyPage />} />
                <Route path="/contact" element={<ContactPage mode="contact" />} />
                <Route path="/louer-votre-bien" element={<ContactPage mode="owner" />} />
              </Routes>
            </PageWrapper>
          </div>
          <Footer />
        </div>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
